import React, { Component, ReactNode } from "react";
import { AppContextType } from "./AppContext";
import { ChordHistoryInteractMode } from "./models/ChordHistoryOptions.model";

interface Props {}
interface State {}

/** i.e. this handler runs before anything below it in the tree sees a keypress.  useful for cancel. */
const USE_CAPTURE = true;

function cycleNextInteractMode(old: ChordHistoryInteractMode) {
  switch (old) {
    case ChordHistoryInteractMode.SOUND:
      return ChordHistoryInteractMode.EDIT;
    case ChordHistoryInteractMode.EDIT:
      return ChordHistoryInteractMode.DELETE;
    case ChordHistoryInteractMode.DELETE:
      return ChordHistoryInteractMode.CHOOSE;
    case ChordHistoryInteractMode.CHOOSE:
      return ChordHistoryInteractMode.SOUND;
  }
}

/**
 * Handle keyboard shortcuts.
 */
export default class AppKeyUpListener extends Component<Props, State> {
  declare context: React.ContextType<typeof AppContextType>;

  /**
   * TODO: define shortcuts for commonly used controls / toggles
   * that's why this is global from the gitgo
   */
  handleKeyUp = (e: KeyboardEvent): any => {
    if (e.key === "Escape") {
      this.context.dispatch({ type: "HideAllPopups" });
    }
    // console.log(e, { shiftKey: e.shiftKey, key: e.key });
    if (e.shiftKey && e.key === "C") {
      const interactMode = cycleNextInteractMode(this.context.chordHistoryOptions.interactMode);
      this.context.dispatch({ type: "EditChordHistoryOptions", payload: { interactMode } });
    }
    if (e.shiftKey && e.key === "N") {
      const oldNoteRow = this.context.chordHistoryOptions.noteRow;
      const hideNotes = !oldNoteRow.hideNotes;
      this.context.dispatch({ type: "EditChordHistoryOptions", payload: { noteRow: { ...oldNoteRow, hideNotes } } });
    }
    if (e.shiftKey && e.key === "M") {
      const isPreferMajor = !this.context.keySelectionOptions.isPreferMajor;
      this.context.dispatch({ type: "EditKeySelectionOptions", payload: { isPreferMajor } });
    }
    if (e.shiftKey && e.key === "I") {
      const autoScroll = !this.context.chordHistoryOptions.autoScroll;
      this.context.dispatch({ type: "EditChordHistoryOptions", payload: { autoScroll } });
    }
  };

  componentDidMount() {
    document.addEventListener("keyup", this.handleKeyUp, USE_CAPTURE);
  }

  componentWillUnmount() {
    document.removeEventListener("keyup", this.handleKeyUp, USE_CAPTURE);
  }

  render(): ReactNode {
    return <></>;
  }
}

AppKeyUpListener.contextType = AppContextType;
